import { SVGProps } from 'react';

export const SvgEyeOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M8.23366 8.23317C7.98804 8.46205 7.79103 8.73805 7.65439 9.04471C7.51775 9.35138 7.44428 9.68242 7.43836 10.0181C7.43243 10.3538 7.49418 10.6872 7.61992 10.9985C7.74566 11.3098 7.9328 11.5926 8.1702 11.83C8.4076 12.0674 8.69038 12.2545 9.00167 12.3802C9.31296 12.506 9.64639 12.5677 9.98207 12.5618C10.3177 12.5559 10.6488 12.4824 10.9555 12.3458C11.2621 12.2091 11.5381 12.0121 11.767 11.7665M8.94198 4.23317C9.29307 4.18943 9.6465 4.16716 10.0003 4.1665C15.8336 4.1665 18.3336 9.99984 18.3336 9.99984C17.9611 10.7974 17.4938 11.5473 16.942 12.2332M5.50866 5.50816C3.85137 6.63701 2.52522 8.18754 1.66699 9.99982C1.66699 9.99982 4.16699 15.8332 10.0003 15.8332C11.5969 15.8374 13.1593 15.3707 14.492 14.4915M1.66699 1.6665L18.3337 18.3332"
      stroke={props.color ?? 'black'}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
